import ReactComponent from '@/components/ReactComponent';
import SituacaoCertidao from '@/dominio/SituacaoCertidao';
import SituacaoCertidaoBusiness from '@/dominio/SituacaoCertidaoJulgamentoBusiness';
import BusinessError from '@/util/BusinessError';
import ErrorUtil from '@/util/ErrorUtil';
import StringUtil from '@/util/StringUtil';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/system';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';

class IconeSituacaoCertidaoJulgamento extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            registro: computed,
            situacao: computed
        });
    }

    get registro() {
        return this.observableProps.registro;
    }

    get situacao() {
        let s;

        try {
            s = SituacaoCertidaoBusiness.getSituacaoCertidaoJulgamento(this.registro);
        } catch (e) {
            if (!(e instanceof BusinessError)) {
                console.error(ErrorUtil.montarMensagemErro(e));
            }
        }

        return s;
    }

    get tooltip() {
        if (!this.situacao) {
            return '';
        }

        return `Certidão ${StringUtil.substituirPrimeiraLetraPorMinuscula(this.situacao.descricao)}`;
    }

    render() {
        if (!this.situacao) {
            return null;
        }

        return (
            <Tooltip title={<Typography>{this.tooltip}</Typography>}>
                <Box
                    as="span"
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'default' }}
                >
                    {SituacaoCertidao.getIcone(this.situacao.id)}
                </Box>
            </Tooltip>
        );
    }
}

IconeSituacaoCertidaoJulgamento.propTypes = {
    registro: PropTypes.object.isRequired
};

export default inject('stores')(observer(IconeSituacaoCertidaoJulgamento));
